import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCreateAccount = () => {
    navigate('/login');
  };

  const handleGenerateBets = () => {
    if (!user) {
      navigate('/login');
    } else if (user.is_pro !== 1) {
      navigate('/checkout');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
      <style>{`
        @keyframes pulseScale {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.06); }
        }
      `}</style>
      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-slate-950/80 backdrop-blur-xl border-b border-white/5' : ''}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo-clover.png" alt="Premiei" className="h-10 w-10" />
            <span className="text-2xl font-bold bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent">Premiei</span>
          </div>
          <div className="flex items-center gap-4">
            {user ? (
              <>
                <Link to="/dashboard" className="px-6 py-2.5 text-sm font-medium text-white/80 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                  Dashboard
                </Link>
                <button
                  onClick={() => {
                    localStorage.removeItem('token');
                    window.location.href = '/';
                  }}
                  className="px-6 py-2.5 text-sm font-medium text-white/80 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  Sair
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="px-6 py-2.5 text-sm font-medium text-white/80 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                  Entrar
                </Link>
                <Link to="/login" className="px-6 py-2.5 text-sm font-bold bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full hover:shadow-lg hover:shadow-cyan-500/30 transition-all whitespace-nowrap cursor-pointer">
                  Criar Conta
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-cyan-500/5 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-16">
            <h1 className="text-6xl md:text-7xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-white via-cyan-200 to-blue-300 bg-clip-text text-transparent">Premiei</span>
              <br />
              <span className="text-4xl md:text-5xl text-white/90">Gere apostas, analise resultados</span>
              <br />
              <span className="text-4xl md:text-5xl text-white/90">e confira automaticamente</span>
            </h1>
            <p className="text-xl text-white/60 mb-10 max-w-3xl mx-auto">
              Todos os jogos da Loteria Federal em um só lugar. Acesso vitalício.
            </p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <button
                onClick={handleCreateAccount}
                className="px-8 py-4 text-base font-bold rounded-full border-2 border-blue-500 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                CRIAR CONTA E LIBERAR AGORA
              </button>
              <Link to="/express" className="px-8 py-4 text-base font-bold bg-gradient-to-r from-emerald-500 to-green-600 rounded-full hover:shadow-2xl hover:shadow-emerald-500/40 transition-transform whitespace-nowrap cursor-pointer" style={{ animation: 'pulseScale 1.5s ease-in-out infinite' }}>
                Aposta EXPRESSA
              </Link>
            </div>
          </div>

          {/* Mega da Virada Card - Destaque */}
          <div className="relative max-w-4xl mx-auto">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 via-pink-500/20 to-purple-500/20 blur-3xl animate-pulse"></div>
            <div className="relative bg-gradient-to-br from-slate-800/90 to-slate-900/90 backdrop-blur-xl border border-orange-500/30 rounded-3xl p-8 shadow-2xl">
              <div className="absolute top-4 right-4">
                <span className="px-4 py-1.5 text-xs font-bold bg-gradient-to-r from-orange-500 to-pink-500 rounded-full whitespace-nowrap">
                  🔥 DESTAQUE
                </span>
              </div>
              <div className="flex items-center justify-between flex-wrap gap-6">
                <div>
                  <h3 className="text-3xl font-bold mb-2 bg-gradient-to-r from-orange-400 to-pink-400 bg-clip-text text-transparent">
                    MEGA DA VIRADA
                  </h3>
                  <p className="text-5xl font-black text-white mb-2">R$ 1.000.000.000</p>
                  <p className="text-white/60 text-sm mb-4">Prêmio estimado</p>
                  <div className="flex items-center gap-2 text-sm text-orange-400">
                    <i className="ri-fire-fill"></i>
                    <span className="font-medium">Alta procura</span>
                  </div>
                </div>
                <Link
                  to="/express"
                  className="px-8 py-4 text-base font-bold bg-gradient-to-r from-orange-500 to-pink-600 rounded-full hover:shadow-2xl hover:shadow-orange-500/40 transition-transform whitespace-nowrap cursor-pointer"
                  style={{ animation: 'pulseScale 1.5s ease-in-out infinite' }}
                >
                  Gerar Apostas Especiais
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16">Por que escolher o Premiei?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: 'ri-magic-line', title: 'Gerador Inteligente', desc: 'Algoritmos avançados para gerar apostas baseadas em estatísticas e padrões' },
              { icon: 'ri-history-line', title: 'Histórico Completo', desc: 'Acesse todos os resultados históricos de todos os jogos da loteria' },
              { icon: 'ri-checkbox-circle-line', title: 'Conferência Automática', desc: 'Marque "vou jogar" e receba notificação se ganhar' },
              { icon: 'ri-file-pdf-line', title: 'PDF para Impressão', desc: 'Gere PDFs prontos para levar na lotérica' },
              { icon: 'ri-notification-3-line', title: 'Notificações em Tempo Real', desc: 'Receba alertas dos resultados assim que saírem' },
              { icon: 'ri-bar-chart-box-line', title: 'Análise Estatística', desc: 'Veja frequências, atrasos e padrões dos números' }
            ].map((item, idx) => (
              <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-cyan-500/30 transition-all cursor-pointer group">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-xl mb-4 group-hover:scale-110 transition-transform">
                  <i className={`${item.icon} text-2xl text-cyan-400`}></i>
                </div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-white/60 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Jogos Suportados */}
      <section className="py-20 px-6 bg-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16">Todos os jogos em um só lugar</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {[
              { name: 'Mega-Sena', color: 'from-green-500 to-emerald-600' },
              { name: 'Quina', color: 'from-purple-500 to-pink-600' },
              { name: 'Lotofácil', color: 'from-pink-500 to-rose-600' },
              { name: 'Lotomania', color: 'from-orange-500 to-red-600' },
              { name: 'Dupla Sena', color: 'from-purple-500 to-indigo-600' },
              { name: 'Timemania', color: 'from-green-500 to-teal-600' },
              { name: 'Federal', color: 'from-blue-500 to-cyan-600' },
              { name: 'Dia de Sorte', color: 'from-yellow-500 to-orange-600' },
              { name: 'Super Sete', color: 'from-red-500 to-pink-600' }
            ].map((jogo, idx) => (
              <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-white/20 transition-all text-center cursor-pointer group">
                <div className={`w-16 h-16 mx-auto mb-3 bg-gradient-to-br ${jogo.color} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform`}>
                  <i className="ri-trophy-line text-2xl text-white"></i>
                </div>
                <h3 className="font-bold text-sm">{jogo.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Como Funciona */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16">Como funciona</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { num: '1', title: 'Gere suas apostas', desc: 'Use nossos algoritmos inteligentes para criar apostas otimizadas' },
              { num: '2', title: 'Marque "vou jogar"', desc: 'Indique quais apostas você realmente vai fazer na lotérica' },
              { num: '3', title: 'Confira automaticamente', desc: 'Receba notificação dos seus resultados assim que saírem' }
            ].map((step, idx) => (
              <div key={idx} className="text-center">
                <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center text-2xl font-bold">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                <p className="text-white/60">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 px-6 bg-gradient-to-r from-cyan-500/10 to-blue-600/10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">Pronto para começar?</h2>
          <p className="text-xl text-white/60 mb-8">Junte-se a milhares de apostadores inteligentes</p>
          <button
            onClick={handleCreateAccount}
            className="px-8 py-4 text-lg font-bold bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full hover:shadow-2xl hover:shadow-cyan-500/40 transition-all whitespace-nowrap cursor-pointer"
          >
            Criar Conta Agora
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-white/10">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-white/40 text-sm">
            © 2025 Premiei. Todos os direitos reservados. | Jogue com responsabilidade.
          </p>
        </div>
      </footer>
    </div>
  );
}
